import PageHero from "../components/PageHero";
import { Reveal } from "../components/motion";

function LegalLayout({ title, updated, children, testid }) {
  return (
    <main data-testid={testid}>
      <PageHero eyebrow="Pocket Bima Insurance Service" title={title} subtitle={`Last updated: ${updated}`} />
      <section className="bg-ice py-20">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <div className="space-y-8 rounded-[2rem] border border-navy/10 bg-white p-8 shadow-soft sm:p-12" data-testid={`${testid}-content`}>
              {children}
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}

const H = ({ children }) => (
  <h2 className="font-display text-xl font-bold text-navy">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-sm leading-relaxed text-charcoal/85">{children}</p>
);

export function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="January 2026" testid="privacy-page">
      <div className="space-y-3">
        <P>Pocket Bima Insurance Service ("PocketBima", "we", "us") respects your privacy. This policy explains what information we collect through this website, why we collect it, and the choices you have.</P>
      </div>
      <div className="space-y-3">
        <H>1. Information We Collect</H>
        <P>When you submit an enquiry or renewal reminder on this website, we collect the details you provide — your name, mobile number, email address, city, the type of insurance you are interested in, any message you choose to share, and where relevant, your policy expiry date. We do not collect payment card details, bank details, or passwords through this website.</P>
      </div>
      <div className="space-y-3">
        <H>2. How We Use Your Information</H>
        <P>Your information is used solely to respond to your enquiry, remind you about an upcoming renewal you asked us to track, and provide relevant insurance assistance and guidance. We may contact you via phone, email or WhatsApp regarding your enquiry.</P>
      </div>
      <div className="space-y-3">
        <H>3. Sharing of Information</H>
        <P>We do not sell your personal information. Where required to assist with your insurance requirement, relevant details may be shared with the respective insurer or authorised channel, with your knowledge.</P>
      </div>
      <div className="space-y-3">
        <H>4. Data Security</H>
        <P>We take reasonable technical and organisational measures to protect the information you share with us. However, no method of transmission over the internet is completely secure, and we encourage you never to share sensitive credentials by email, chat or web forms.</P>
      </div>
      <div className="space-y-3">
        <H>5. Your Choices</H>
        <P>You may request access, correction or deletion of your personal information at any time by writing to us at pocketbimaofficial@gmail.com. If you have asked for a renewal reminder and change your mind, contact us and we will remove it.</P>
      </div>
      <div className="space-y-3">
        <H>6. Cookies and Analytics</H>
        <P>This website may use basic cookies or similar technologies for essential functionality and to understand aggregate visitor behaviour, such as which pages are visited most. We do not use cookies to sell data or build advertising profiles. You can control cookies through your browser settings.</P>
      </div>
      <div className="space-y-3">
        <H>7. Data Retention</H>
        <P>We retain enquiry and reminder details for as long as needed to assist you and maintain basic business records, after which they may be deleted or anonymised. If you would like your details removed sooner, simply ask.</P>
      </div>
      <div className="space-y-3">
        <H>8. Third-Party Links</H>
        <P>Our website links to third-party services such as WhatsApp and Google Maps. When you use those services, their own privacy policies apply, and we encourage you to read them.</P>
      </div>
      <div className="space-y-3">
        <H>9. Changes to This Policy</H>
        <P>We may update this policy from time to time. The "last updated" date at the top of this page shows when it was last revised. Continued use of the website after an update means you accept the revised policy.</P>
      </div>
      <div className="space-y-3">
        <H>10. Contact</H>
        <P>For any privacy-related questions, contact us at pocketbimaofficial@gmail.com or call +91 95980 63001. Our head office is at N-303, Stellar Jeevan, GH-03, Sector 1, Greater Noida West, U.P. - 201318, and our branch office is near Hotel Anandi Inn, Diggital, Patel Nagar, Orai, Uttar Pradesh 285001.</P>
      </div>
    </LegalLayout>
  );
}

export function TermsConditions() {
  return (
    <LegalLayout title="Terms & Conditions" updated="January 2026" testid="terms-page">
      <div className="space-y-3">
        <P>These terms govern your use of the Pocket Bima Insurance Service website. By using this website, you accept these terms. Please read them carefully.</P>
      </div>
      <div className="space-y-3">
        <H>1. About Pocket Bima Insurance Service</H>
        <P>Pocket Bima Insurance Service provides insurance solutions and assistance. It is not an insurance company or insurer. Insurance products are underwritten and issued by the respective insurance companies, who are solely responsible for policy terms, coverage decisions and claim settlement.</P>
      </div>
      <div className="space-y-3">
        <H>2. Use of This Website</H>
        <P>The content on this website — including guides, FAQs and blog articles — is for general information and education purposes only. It does not constitute insurance advice, financial advice, an offer, or a solicitation to purchase any insurance product.</P>
      </div>
      <div className="space-y-3">
        <H>3. Enquiries and Reminders</H>
        <P>Submitting an enquiry or renewal reminder through this website does not create a policy, cover, or any binding contract of insurance. A contract of insurance comes into existence only when the respective insurer issues a policy document.</P>
      </div>
      <div className="space-y-3">
        <H>4. Policy Terms</H>
        <P>Policy availability, coverage, premiums, terms and conditions are subject to the respective insurer's policy terms and applicable regulations. Please read the policy wording and related documents carefully before concluding a sale.</P>
      </div>
      <div className="space-y-3">
        <H>5. Accuracy of Information</H>
        <P>While we strive to keep information accurate, current and easy to understand, we make no warranties about completeness or accuracy and may update content at any time without notice. Insurance products and regulations change; the insurer's latest policy document always prevails.</P>
      </div>
      <div className="space-y-3">
        <H>6. Limitation of Liability</H>
        <P>Pocket Bima Insurance Service shall not be liable for any loss arising from reliance on the information provided on this website. Insurance is the subject matter of solicitation.</P>
      </div>
      <div className="space-y-3">
        <H>7. Intellectual Property</H>
        <P>The Pocket Bima name, logo, website design, text and original illustrations on this website belong to Pocket Bima Insurance Service. You may not copy, reproduce or republish them for commercial use without written permission. Sharing links to our public pages is always welcome.</P>
      </div>
      <div className="space-y-3">
        <H>8. Third-Party Websites and Insurers</H>
        <P>Links to third-party sites (including insurers, WhatsApp, Google Maps and social media) are provided for convenience. We do not control and are not responsible for their content, availability or practices.</P>
      </div>
      <div className="space-y-3">
        <H>9. Governing Law</H>
        <P>These terms are governed by the laws of India. Any disputes arising from the use of this website shall be subject to the jurisdiction of the courts in Gautam Buddh Nagar, Uttar Pradesh.</P>
      </div>
      <div className="space-y-3">
        <H>10. Contact</H>
        <P>Questions about these terms? Write to pocketbimaofficial@gmail.com or call +91 95980 63001.</P>
      </div>
    </LegalLayout>
  );
}

export function Disclaimer() {
  return (
    <LegalLayout title="Disclaimer" updated="January 2026" testid="disclaimer-page">
      <div className="space-y-3">
        <H>Nature of Services</H>
        <P>Pocket Bima Insurance Service provides insurance solutions and assistance. It is not an insurance company, insurer, or underwriter, and does not itself issue insurance policies. All policies are issued by the respective insurance companies, and all final decisions rest with them.</P>
      </div>
      <div className="space-y-3">
        <H>General Information Only</H>
        <P>The articles, FAQs and guides on this website simplify insurance concepts for general understanding. They are not personalised advice. Your suitability for any product depends on your individual situation, health, assets and goals — please talk to us or a qualified advisor before deciding.</P>
      </div>
      <div className="space-y-3">
        <H>No Guaranteed Outcomes</H>
        <P>Nothing on this website constitutes a guarantee of coverage, claim settlement, savings, or premium levels. Benefits, coverage, exclusions and premiums vary by insurer and product, and are determined solely by the insurer.</P>
      </div>
      <div className="space-y-3">
        <H>Insurer Terms Apply</H>
        <P>Policy availability, coverage, premiums, terms and conditions are subject to the respective insurer's policy terms and applicable regulations. The insurance contract is solely between the policyholder and the insurer.</P>
      </div>
      <div className="space-y-3">
        <H>Read Before You Buy</H>
        <P>Visitors are advised to read policy documents, brochures and benefit illustrations carefully before concluding a sale. Insurance is the subject matter of solicitation.</P>
      </div>
      <div className="space-y-3">
        <H>External Links</H>
        <P>This website contains links to external websites and services. Pocket Bima Insurance Service does not endorse and is not responsible for the content, accuracy or practices of third-party websites.</P>
      </div>
      <div className="space-y-3">
        <H>A Note on Compliance</H>
        <P>Insurance in India is regulated by the Insurance Regulatory and Development Authority of India (IRDAI), and every insurer's product is governed by its filed terms and conditions. When we assist you, our role is to help you understand options and processes clearly — the final contract, premium and claim decisions always rest with the insurer you choose. If anything on this website ever seems to conflict with an official policy document, the policy document is the authority.</P>
      </div>
      <div className="space-y-3">
        <H>Contact</H>
        <P>Questions about this disclaimer? Write to pocketbimaofficial@gmail.com or call +91 95980 63001. You can also visit us at N-303, Stellar Jeevan, Sector 1, Greater Noida West, U.P. - 201318, or at our Orai branch near Hotel Anandi Inn, Diggital, Patel Nagar, Orai, Uttar Pradesh 285001.</P>
      </div>
    </LegalLayout>
  );
}
